module.exports = __webpack_public_path__ + "static/img/our-people-we-live-hero.23c8c6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/our-people-we-live-hero.jpg
// module id = HdCH
// module chunks = 0